import { useTranslation } from 'react-i18next'

import Page from '../../../components/Page'
import ConfigurationForm from '../../../components/forms/ConfigurationForm/ConfigurationForm'

const ConfigurationAdd = () => {
  const { t } = useTranslation()

  return (
    <Page pageTitle={t('configuration.add.title')}>
      <ConfigurationForm />
    </Page>
  )
}

export default ConfigurationAdd
